import React from "react";

import { Button } from "js/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "js/components/ui/dialog";

interface TermsAndConditionsProps {
  open: boolean;
  onClose: () => void;
}

const TermsAndConditionsContent: React.FC = () => {
  return (
    <div className="[&_h2]:text-xl [&_h2]:font-bold [&_h2]:mt-6 [&_h2]:mb-4 [&_h2]:text-gray-900 [&_p]:mb-4 [&_p]:text-gray-700 [&_ol]:mb-4 [&_ol]:pl-6 [&_ul]:mb-4 [&_ul]:pl-6 [&_li]:mb-2 [&_table]:w-full [&_table]:mb-4 [&_th]:text-left [&_th]:font-semibold [&_th]:p-2 [&_th]:border-b [&_td]:p-2 [&_td]:border-b [&_a]:text-blue-600 [&_a]:underline [&_strong]:font-bold">
      <h2>Condiciones Generales.</h2>
      <p>
        Bienvenido. Nuestra empresa es la encargada de operar el Sitio. Los
        presentes términos y condiciones generales de uso tienen por objeto
        regular el acceso y uso que hagas del Sitio, asimismo, para efectos de
        claridad en adelante nos referiremos a usted, como el "Usuario" o “El
        Cliente”.
      </p>
      <p>
        Al entrar al sitio, el usuario manifiesta su conformidad y aceptación
        completa de las Condiciones.
      </p>
      <p>
        Las presentes Condiciones podrán estar sujetas a cualquier tipo de
        variación, modificación, cambio, ajuste, adición o complemento en el
        futuro o en el momento en el que lo considere oportuno nuestra empresa,
        en el entendido que, dichas actualizaciones surtirán sus efectos en el
        momento en que las publiquemos en el Sitio, y el Usuario deberá aceptar
        expresamente dichas actualizaciones a nuestras Condiciones.
      </p>
      <p>
        Nuestros servicios sólo están disponibles para personas que tengan
        capacidad legal para contratar. No podrán utilizar los servicios, los
        menores de edad, quienes no tengan esa capacidad o las personas que
        hayan sido suspendidas o dadas de baja del sistema de El Sitio.
      </p>
      <p>
        El sitio es apto para todo tipo de personas, incluyendo la Población
        Vulnerable.
      </p>
      <p>
        La información y Publicidad que se proporciona en el sitio es veraz,
        comprobable, clara, por lo que si generase confusión al Usuario favor de
        solicitar información previa a la contratación a los medios de
        comunicación proporcionados.
      </p>
      <p>
        El sitio cuenta con un mecanismo para que el Consumidor, cliente o
        usuario, acepte los términos y condiciones, sin embargo, es distinta
        para el tratamiento de los Datos personales de los usuarios, para lo que
        se deberá aceptar a su vez el mismo aviso de privacidad.
      </p>
      <p>
        Toda la información general respecto a la identificación de la empresa
        se encuentra al final de los presentes términos y condiciones.
      </p>

      <h2>Servicios ofrecidos por la empresa.</h2>
      <p>
        Los servicios que la empresa ofrece son los relacionados en la parte
        final del presente documento para su mejor identificación, en la
        pestaña, apartado o liga particular de estos, lo que permite al Usuario
        tomar una decisión informada relacionada con la transacción comercial.
      </p>
      <p>Los servicios ofrecidos por la empresa muestran:</p>
      <p>
        a) La descripción de los mismos, incluyendo sus especificaciones. b) El
        monto total a pagar por cada uno de ellos, en moneda nacional.
      </p>
      <p>
        El sitio exhibe imágenes de servicios con la mayor precisión posible. No
        obstante, no podemos garantizar que los colores que usted ve coincidan
        con el color del entregable del servicio, ya que la visualización del
        color depende, en parte, del monitor que utilice y en ciertas ocasiones
        de las condiciones físicas de la persona y de las condiciones
        ambientales y de luz del lugar en que se encuentre.
      </p>
      <p>
        Los servicios consumibles serán entregados al Usuario con una fecha de
        caducidad indicado en cada uno de ellos.
      </p>

      <h2>Precios.</h2>
      <p>
        Los precios a pagar por los servicios que el Usuario solicite son
        aquellos mostrados en este sitio en el momento en que el usuario realice
        su pedido, y detallados en la confirmación del mismo, incluyendo IVA o
        cualquier otro impuesto de aplicación, o cualquier otro según sea el
        caso. Asimismo, se puede consultar los precios de los servicios en el
        sitio.
      </p>
      <p>
        Los precios pueden sufrir variaciones: dichas variaciones serán siempre
        comunicadas al cliente, que tendrá el derecho de no aceptarlas,
        rescindir el contrato y/o anular la entrega tras las variaciones de
        precios, siempre que la empresa no acepte llevar a cabo la entrega del
        servicio con los precios en vigor en el momento de efectuar el pedido.
      </p>

      <h2>
        Cuenta o ingreso a la plataforma para la contratación del servicio.
      </h2>
      <p>
        El servicio prestado por la Empresa, podrá o no, requerir el registro
        mediante cuenta o Log in, sin embargo, en cualquier caso se sujetará a
        lo siguiente:
      </p>
      <p>
        El Registro con "usuario" y "contraseña" no es obligatorio, sin embargo,
        el cliente en su caso, deberá proteger el usuario y contraseña
        utilizados para registrarse en el sitio y es responsable de cualquier
        actividad o acción llevadas a cabo con su usuario y su contraseña.
      </p>
      <p>
        No obstante, para lograr una transacción comercial es necesario que el
        cliente proporcione información personal.
      </p>
      <p>
        El usuario, manifiesta que los datos que proporcione para contratar
        nuestros servicios son reales, veraces, exactos, lícitos y comprobables,
        y que libera a la empresa de cualquier responsabilidad derivada de la
        veracidad, idoneidad, exactitud, licitud y comprobación de los mismos,
        también se autoriza a verificar sus datos, ya sea de manera propia o a
        través de terceros, por lo que si se llegase a comprobar que la
        información que se proporciona es falsa, inexacta o ilícita, la empresa,
        a discreción, podrá negar el acceso al Sitio y a eliminar la cuenta de
        usuario, además de ser responsable de los daños y perjuicios generados.
        Todos los datos proporcionados se rigen de acuerdo a nuestra Política de
        Privacidad la cual se podrá encontrar en el mismo sitio.
      </p>
      <p>
        El cliente se compromete a mantener actualizada en todo momento la
        información personal.
      </p>
      <p>
        El cliente acepta notificar dentro del día siguiente a la empresa de
        cualquier utilización no autorizada de su usuario y contraseña, o bien
        cualquier otra infracción en la seguridad a sus datos.
      </p>
      <p>
        La Empresa podrá en cualquier momento suspender o cerrar su Cuenta, y su
        capacidad para utilizar uno o más de los Servicios, o una parte de los
        Servicios, y ello de manera automática y sin necesidad de trámite
        alguno, tras remitirle por correo electrónico o por correo postal un
        requerimiento formal para que ponga fin a una determinada violación o
        aporte prueba de sus credenciales y demás documentación comprobatoria de
        su personalidad y/o capacidad que no se hubiera visto atendido
        inmediatamente, si se confirmara, o si la empresa tuviera motivos
        razonables para creer que usted ha incurrido en incumplimiento a los
        presentes términos y condiciones.
      </p>
      <p>
        Si usted contara con más de una Cuenta, la empresa se reserva el derecho
        de suprimir todas las Cuentas que usted hubiera abierto.
      </p>
      <p>
        En cualquier momento usted podrá poner fin a su Cuenta o a la
        suscripción a un determinado Servicio o Servicios, de manera automática
        y sin necesidad de trámite judicial alguno, notificándolo mediante el
        mismo procedimiento establecido de los presentes Términos y enviando su
        escrito al correo electrónico ahí proporcionado.
      </p>
      <p>
        Si no acepta los presentes Términos no podrá utilizar los Servicios y
        deberá enviar a la empresa una solicitud para que ponga fin a su Cuenta
        y/o a las correspondientes suscripciones en el entendido que en tanto no
        acepte los Términos, termine su proceso de registro o envíe la solicitud
        establecida en este párrafo, su Cuenta permanecerá existente, pero
        inactiva.
      </p>
      <p>
        Tenga presente que, si decide poner fin a su suscripción, no se
        practicará reembolso alguno, ni total ni parcial, de los importes ya
        abonados por el período de suscripción en vigor o por cualquier relación
        comercial vigente con algún tercero u otro Usuario relacionado con los
        Servicios.
      </p>
      <p>
        La Empresa se reserva el derecho de recuperar los costes, suplementos y
        cargos en que se hubiera incurrido antes de la cancelación de su Cuenta
        o de su suscripción a un determinado Servicio o Servicios. Por otra
        parte, será responsabilidad suya pagar las cantidades que pudiera
        adeudar a otros proveedores de Contenidos antes de la terminación de su
        Cuenta. Las cantidades atrasadas o los costes no abonados, así como
        cualquier otro problema no resuelto con respecto a los Servicios,
        deberán liquidarse antes de cualquier posible apertura de una nueva
        Cuenta o la cancelación de una existente.
      </p>
      <p>
        Con sujeción a la observancia del procedimiento de cancelación
        anteriormente indicado, la cancelación de su Cuenta y/o de su
        suscripción surtirá efecto en un período de tiempo razonable
        inmediatamente después de la recepción de su carta en el departamento de
        atención al cliente de la empresa mediante los medios al efecto
        establecidos en el presente punto.
      </p>
      <p>
        En los supuestos de cancelación o de suspensión de su Cuenta, la empresa
        podrá suprimir y en cuyo caso Usted perderá, su perfil y la información
        relacionada que hubiera facilitado, junto con cualquier Contenido que
        pudiera haber publicado, cargado o puesto a disposición de terceros en
        los Servicios y en especial, sin carácter exhaustivo, su Nombre de
        usuario.
      </p>
      <p>
        En los supuestos de terminación de la Cuenta, deberá de dejar
        inmediatamente de utilizar los Servicios y proceder a destruir cualquier
        documentación relativa a los medios que tuviera almacenada en cualquier
        tipo de soporte.
      </p>
      <p>
        En los supuestos de terminación de su Cuenta, no podrá participar
        nuevamente en los Servicios sin la expresa autorización de la empresa.
        Para beneficiarse nuevamente de los Servicios, Usted deberá solicitarlo
        mediante el correo electrónico anteriormente citado, siguiendo los
        mismos criterios que para la cancelación, la autorización para la
        reactivación o Creación de una nueva Cuenta.
      </p>
      <p>
        En los supuestos de terminación de su Cuenta, o de uno o varios
        Servicios asociados a su Cuenta, no se incluirá en su haber ningún
        período de uso de los Servicios en línea ni ningún otro tipo de crédito
        ni se le convertirán en metálico, ni se realizará ningún otro tipo de
        reembolso, y dejará de tener acceso a su Cuenta o a cualquier otro
        derecho asociado a su Cuenta o a los Servicios en cuestión.
      </p>
      <p>
        Para lo no establecido en los presentes Términos en relación con este
        punto, se atenderá lo señalado en el Aviso de Privacidad mismo que
        contiene el ejercicio de los derechos de Acceso, Rectificación,
        Cancelación u Oposición de los datos personales y cualquier información
        de los usuarios, así como el procedimiento para ejercerlos.
      </p>

      <h2> Política de uso de datos. </h2>
      <p>
        Además de lo dispuesto en la política de privacidad y aviso de
        privacidad respectiva, el cliente autoriza para hacer uso de toda la
        información publicada, para fines publicitarios, estadísticos y de
        evaluación, aun después de cerrada su Cuenta y por todo el tiempo que la
        ley aplicable, en su caso, lo permita.
      </p>

      <h2> Proceso de adquisición del Entregable del servicio o Servicio. </h2>
      <p>
        El Cliente a fin de realizar la adquisición de los servicios de le
        empresa deberá seguir los siguientes pasos:
      </p>
      <ol>
        <li>
          Acceder a la plataforma web:{" "}
          <a href="https://www.multiburo.com.mx/" target="_blank">
            www.multiburo.com.mx
          </a>
        </li>
        <li>
          Proporcionar datos, ya sea mediante los formularios o bien, si es
          solicitado por la empresa mediante correo{" "}
          <a href="mailto:solicitudes@multiburo.com.mx">
            solicitudes@multiburo.com.mx
          </a>{" "}
          o al celular +52332946227
        </li>
        <li>
          Completar toda la información requerida por la empresa, incluyendo
          información de terceros.
        </li>
        <li>
          Aceptar los presentes términos y condiciones y el correspondiente
          aviso de privacidad
        </li>
        <li>
          En su caso, obtener la autorización de tratamiento de datos personales
          de las terceras personas involucradas, cuyos datos sean ingresados a
          la plataforma.
        </li>
        <li>
          En caso de ser requerida por la empresa, ingresar los elementos y
          requisitos de la firma electrónica digital, sea simple o sea avanzada
          (ej. FIEL), de conformidad a la legislación aplicable a la materia.
        </li>
      </ol>

      <p>
        El cliente siempre puede realizar cambios en cualquier selección de
        servicios, así como consultar información sobre otros servicios, antes
        de aceptar la transacción.
      </p>
      <p>
        Previo a aceptar, el cliente podrá verificar la información resumida
        sobre el entregable del servicio que va a adquirir, así como cualquier
        información de entrega, precios y en su caso, costos de envío, antes de
        aceptar la transacción, incluyendo la siguiente:
      </p>
      <ol type="a">
        <li>
          El costo total de la transacción comercial, incluidos en su caso, los
          descuentos disponibles y todos los cargos aplicables;
        </li>
        <li>
          Los impuestos en su caso, adicionales al IVA que en su caso apliquen;
        </li>
        <li>En su caso, el costo de envío;</li>
        <li>
          En su caso, los cargos adicionales derivado del mecanismo de pago que
          se utilice;
        </li>
      </ol>
      <p>
        Se mostrarán los medios de pago disponibles para completar la
        Transacción comercial, así como el mecanismo que permita al cliente
        seleccionar una opción de pago, de forma que se garantice la aceptación
        a las condiciones del mismo.
      </p>
      <p>
        En el sitio se mostrarán al cliente los métodos de entrega disponibles.
      </p>
      <p>
        El sitio, informará al cliente las condiciones de envío del entregable,
        los costos según el método de envío, los plazos estimados de entrega,
        las responsabilidades en caso de rechazos, retardos, demoras o en su
        caso cobros derivados de operación del servicio postal del país de
        origen o destino.
      </p>
      <p>
        Cada solicitud realizado a través del sitio estará regido por estas
        Condiciones. Al realizar una solicitud, el Cliente reconoce que ha
        leído, comprendido y aceptado, sin reserva alguna, las presentes
        Condiciones, por lo que le recordamos la conveniencia de que las lea
        detalladamente.
      </p>
      <p>
        Los servicios son ofrecidos en esta página web dentro de los límites de
        las cantidades disponibles. En caso de que su solicitud excediera de los
        alcances de la empresa, se le informaría inmediatamente de ello.
      </p>
      <p>
        Con la aceptación de las presentes Condiciones Generales, las
        solicitudes realizadas y confirmadas por la empresa constituirán un
        contrato vinculante y plenamente eficaz entre las partes.
      </p>
      <p>
        La empresa se reserva el derecho de rechazar solicitudes, por causas de
        fuerza mayor, incumplimiento de condiciones, afectación a terceros o en
        caso de impago.
      </p>
      <p>
        La información registrada constituye prueba absoluta de la solicitud y
        de toda la transacción.
      </p>
      <p>
        En su caso, la información registrada por el sistema de pago constituye
        prueba absoluta de las transacciones financieras.
      </p>

      <h2>Facturación.</h2>
      <p>
        Se emitirá una factura por cada solicitud siempre y cuando se cuenten
        con todos los datos y requisitos de ley para tal efecto. Se podrá
        solicitar la factura al correo de contacto dentro del mes en curso.
      </p>

      <h2>Políticas de Envío y Entregas.</h2>
      <p>
        La empresa a fin de realizar la entrega de los servicios adquiridos por
        el cliente seguirá lo siguiente:
      </p>
      <ol>
        <li>
          Enviará al usuario, a otros usuarios según sea el caso de
          autorización, o a las personas autorizadas para tal efecto, el PDF
          resultado del servicio, a los correos electrónicos proporcionados por
          estos.
        </li>
      </ol>
      <p>
        La empresa llevará a cabo el envío de los entregables del servicios
        adquiridos exclusivamente en la dirección sea electrónica o física de
        destino especificada en la solicitud.
      </p>
      <p>
        Asimismo, el cliente reconoce y acepta que, en caso de un posible robo o
        extravío de la información, entregable de los servicios u otros, no
        imputable a la empresa, éste llevará a cabo el proceso de investigación
        correspondiente y determinará los pasos a seguir para después
        comunicárselos al cliente y definir alternativas de solución.
      </p>

      <h2>Políticas de cancelaciones de servicios o servicios.</h2>
      <p>La empresa determina las siguientes políticas:</p>

      <ol>
        <li>
          Los usuarios, o clientes podrán cancelar la solicitud previo al pago
          del mismo, siendo que una vez realizado el mismo, la empresa mediante
          su plataforma inicia el proceso de busqueda y contratación de terceros
          proveedores.
        </li>
      </ol>

      <h2>Políticas de cancelaciones de servicios o servicios.</h2>
      <p>La empresa determina las siguientes políticas:</p>
      <ol>
        <li>No existirán cambios relativos a la contratación del servicio.</li>
      </ol>
      <p>
        De conformidad a la Ley Federal de Protección al Consumidor y su
        reglamento, existen servicios adquiridos por el cliente que por su
        naturaleza no podrán ser cambiados o devueltos, por lo que se informa de
        dicha situación al cliente.
      </p>

      <h2>Políticas de devoluciones de servicios o servicios.</h2>
      <p>La empresa determina las siguientes políticas:</p>
      <ol>
        <li>
          Los servicios no podrán ser devueltos o cambiados, siendo que una vez
          realizado el mismo, la empresa mediante su plataforma inicia el
          proceso de busqueda y contratación de terceros proveedores.
        </li>
      </ol>
      <p>
        De conformidad a la Ley Federal de Protección al Consumidor y su
        reglamento, existen servicios adquiridos por el cliente que por su
        naturaleza no podrán ser cambiados o devueltos, por lo que se informa de
        dicha situación al cliente.
      </p>

      <h2>Políticas de Garantías.</h2>
      <p>La empresa determina las siguientes políticas:</p>
      <ol>
        <li>
          La empresa no garantiza la idoneidad del servicios, de conformidad al
          segundo párrafo del apartado “Limitación y exclusión de
          responsabilidad”.
        </li>
      </ol>

      <h2>Uso de los servicios.</h2>
      <p>
        Como parte de los Servicios ofrecidos, La Empresa, incluye herramientas
        de software altamente funcionales para procesar y automatizar la
        información, como lo pueden ser conexiones a fuentes o bases de datos
        externas que se comparte por los Usuarios en la plataforma web y
        contenidos, a efecto de brindar un mejor Servicio. No obstante, La
        Empresa no garantiza la veracidad de la información que los Usuarios
        comparten en las Plataformas Web, ni la proporcionada por las diversas
        fuentes de datos. Por lo anterior, La Empresa no tiene ninguna
        responsabilidad respecto a la veracidad de la información que aporten
        los Usuarios a la plataforma web o que terceros proporcionen a la
        Empresa.
      </p>
      <p>
        Los Servicios están destinados únicamente a su uso personal, en su caso,
        de las terceras personas involucradas y el cliente no deberá en ningún
        caso utilizarlos en modo alguno diverso a los fines comerciales para los
        cuales son proporcionados.
      </p>
      <p>
        El cliente se compromete a no vender, arrendar ni comercializar los
        mismos. Se obliga igualmente a no adaptar, modificar, descompilar,
        desmontar, someter a ingeniería inversa, traducir, adaptar, reproducir,
        distribuir, difundir o transferir ninguna información, ningún programa
        informático y, en general, ninguno de los elementos de los Servicios o
        del propio sitio. Está expresamente prohibido la re-publicación
        (re-posting) o el uso automatizado o el uso masivo de los mismos.
      </p>
      <p>
        El cliente autoriza a la empresa a transmitir el resultado o entregable
        del servicio a terceras personas, mismas que le podrán el uso que ellas
        mismas tengan autorizado para tal efecto. La Empresa no se hace
        responsable por el uso o tratamiento del entregable del servicio que las
        terceras personas involucradas o autorizadas puedan darle a dicha
        información.
      </p>

      <h2>Normas de conducta.</h2>
      <p>
        Concretamente, el Cliente se compromete a no realizar, ni directa ni
        indirectamente, ninguna de las siguientes conductas:
      </p>
      <ul>
        <li>
          Utilizar cualquier elemento o contenido que pudiera constituir una
          violación de los derechos de propiedad intelectual u otros derechos,
          como lo puede ser el secreto industrial, el derecho a la intimidad y/o
          a la propia imagen, y/o de cualquier otro derecho;
        </li>
        <li>
          Crear, utilizar, compartir y/o editar, por cualquier medio (en foros,
          correos electrónicos, mensajes, perfiles públicos o por cualquier otro
          medio), dentro del ámbito de los Servicios, cualquier material (texto,
          palabras, imágenes, sonidos, vídeos, etcétera) o contenido que de
          acuerdo con los presentes Términos, la ley, las costumbres
          generalmente aceptadas y el orden público, resulte agresivo,
          amenazante, malicioso, difamatorio, incierto, pornográfico, pedófilo,
          obsceno, vulgar, racista, xenófobo, susceptible de incitar al odio, o
          sexualmente explícito, violento, contrario a la moral o que, de
          cualquier otro modo, resulte inaceptable;
        </li>
        <li>
          Crear, utilizar, compartir y/o editar, por cualquier medio (en foros,
          correos electrónicos, mensajes, perfiles públicos o por cualquier otro
          medio), dentro del ámbito de los Servicios, cualquier material (texto,
          palabras, imágenes, sonidos, vídeos, etcétera) que resultara
          constitutivo de una violación de una obligación de confidencialidad, o
          que incitara a la comisión de hechos ilícitos (en particular, a la
          piratería, el rompimiento de claves (cracking) o la difusión de
          programas informáticos falsificados); Llevar a cabo actividades
          dirigidas a acceder a elementos o funciones de los Servicios cuyo uso
          no hubiera sido autorizado;
        </li>
        <li>
          Arreglar, modificar, traducir, adaptar, reproducir, indiciar, copiar
          y/o extraer, por cualquier procedimiento, cualquier información,
          programa informático, base de datos, entregable del servicio o
          cualquier otro elemento, sin la previa autorización expresa;
          Modificar, distorsionar, bloquear, cargar anormalmente, interrumpir,
          ralentizar y/o dificultar el normal funcionamiento de la totalidad o
          de parte del sitio, o la accesibilidad de otros clientes a los mismos,
          o el funcionamiento de las redes asociadas de los mismos, o la
          tentativa de llevar a cabo cualquiera de las anteriores acciones;
        </li>
        <li>
          Transmitir o propagar cualquier virus, troyano, gusano, bomba, fichero
          corrompido y/o cualquier dispositivo destructivo semejante o cualquier
          tipo de dato corrompido dentro del ámbito del sitio, y/u organizar,
          participar en, o estar involucrado de cualquier modo en cualquier tipo
          de ataque a los servidores;
        </li>
        <li>
          Crear, utilizar y/o difundir programas informáticos automáticos o
          “macros”, incluidos, sin carácter exhaustivo, programas o aplicaciones
          “cheats”, “hacks”, “mods, “bots” y “trainers”, y/o utilizar los
          Servicios a través de un sitio espejo (mirror site);
        </li>
        <li>
          Crear o facilitar cualquier otro mecanismo que permita la utilización
          de los Servicios por parte de otras personas, como por ejemplo
          emuladores de servidores;
        </li>
        <li>
          Acosar a otros clientes, enviarles mensajes no solicitados con
          finalidades de investigación comercial, utilizar los Servicios con
          fines de operaciones de investigación, competencia, ventas piramidales
          u otros semejantes, o para el envío masivo de correos electrónicos, de
          correo basura (spam) o de elementos promocionales o publicitarios no
          solicitados, ya fuera con fines comerciales o de cualquier otro tipo;
        </li>
        <li>
          Utilizar información incorrecta, utilizar la Cuenta de otro cliente,
          asumir la identidad de otra persona o presentar credenciales falsas en
          sus relaciones con cualquier persona física o jurídica dentro del
          ámbito de los Servicios o durante la utilización de los mismos;
        </li>
        <li>
          Utilizar cualquier mecanismo no expresamente autorizado por la empresa
          para la captación o interceptación de datos intercambiados por otros
          clientes dentro del ámbito del sitio, o los nombres/nombres de
          pantalla y/o contraseñas de cualquier otro Usuario; Intentar obtener
          una contraseña o información relativa a una Cuenta, o cualquier otra
          información de naturaleza privada, de cualquier otro cliente de los
          Servicios y/o vender, alquilar, compartir, prestar y/o de cualquier
          otro modo transferir a cualquier tercero ajeno su Cuenta y/o los
          mecanismos de acceso a la misma y/o, de cualquier otro modo, permitir
          que cualquier tercero ajeno se beneficie de su Cuenta;
        </li>
        <li>
          Realizar un uso inapropiado del sistema de ayuda o de los botones de
          reclamaciones. Subir información falsa y/o engañosa con cualquier fin.
        </li>
      </ul>

      <h2>Sanciones.</h2>
      <p>
        En caso de que el cliente incumpla con los presentes términos, o bien
        incurra en algunas de las conductas señaladas en el punto inmediato
        anterior, la empresa podrá discrecionalmente ejercer las siguientes
        acciones:
      </p>
      <p>
        Cancelar la cuenta del cliente de forma temporal o permanente o en su
        caso negar la entrega o prestación del servicio.
      </p>
      <p>
        Proceder legalmente solicitando el pago de daños y perjuicios que en su
        momento se llegasen a causar.
      </p>

      <h2>Disposiciones de Propiedad intelectual.</h2>
      <p>
        El sitio está diseñado, editado, producido y gestionado por La Empresa,
        así es, que todo el contenido, así como todos los derechos de propiedad
        intelectual e industrial vinculados con el diseño y desarrollo de los
        mismos, con la selección de estos elementos, con su presentación y
        disposición, y su diseño pertenecen a esta.
      </p>
      <p>
        Del mismo modo, las marcas comerciales, los nombres de dominio, los
        acrónimos, los logotipos, los dibujos y los demás elementos que aparecen
        en el sitio son propiedad de la empresa.
      </p>
      <p>
        El sitio, así como la totalidad de su contenido está protegido por la
        legislación en materia de derechos de autor y por la legislación en
        materia de propiedad industrial, así como por los convenios
        internacionales y por el resto de la legislación que protege la
        propiedad intelectual e industrial y los correspondientes derechos
        exclusivos.
      </p>
      <p>
        Queda prohibido cualquier uso, comunicación pública, reproducción,
        exhibición, distribución y puesta a disposición del público de los
        citados elementos, o de la totalidad o de parte del sitio, con
        independencia de la forma y de la causa de la misma, sin la previa
        autorización de la empresa.
      </p>

      <h2>Medidas de protección técnica y gestión de derechos digitales.</h2>
      <p>
        Determinados Servicios pueden estar protegidos por medidas de protección
        técnica y derechos de gestión digital, en especial, y sin carácter
        exhaustivo, medida de protección física, marca de agua, llaves
        digitales, activación en línea, firmas electrónicas, e-firma del SAT,
        entre otros.
      </p>
      <p>
        Para acceder a ciertas funciones o Servicios, y en algunos casos para
        desbloquear contenidos exclusivos, proceder a ciertos Servicios o
        contraer acuerdos con otros Usuarios, podría ser necesaria o exigible
        una conexión a internet de banda ancha, contar con una Cuenta y
        contraseña y contar con una e-firma del SAT, entre otros requisitos.
      </p>
      <p>
        La Empresa puede cancelar, a su entera discreción, el acceso a uno o
        varios Servicios o funciones en línea mediante un preaviso publicado con
        una antelación.
      </p>
      <p>
        Los Servicios podrán ser protegidos mediante software de gestión de
        derechos digitales (“software DRM”). En tal caso, mediante estos
        Términos usted acepta, reconoce y autoriza lo siguiente en relación con
        el software DRM: (i) la instalación de La Empresa, es decir del
        Servicio, podrá provocar la instalación del software DRM en su equipo;
        (ii) el software DRM puede limitar el número de instalaciones del
        producto; (iii) el software DRM puede instalar en su equipo los
        componentes adicionales necesarios para la protección contra copias; y
        (iv) durante la instalación y/o primera ejecución del producto puede ser
        necesaria una conexión en línea para desbloquear el producto a través
        del software DRM. Lo anterior para efecto de aplicaciones móviles y
        plug-ins en exploradores.
      </p>
      <p>
        La Empresa declina toda responsabilidad con respecto a los componentes
        que cualquier software DRM pueda instalar en su equipo. Para obtener
        información adicional, visite el sitio web del software DRM que aparezca
        durante la instalación del Servicio. Es posible que se requiera una
        conexión a internet, una cuenta para instalar dicho programa y
        registrarse con el código serie de un solo uso adjunto para ejecutar y
        acceder a los servicios en línea y a las funciones de este Servicio. Es
        posible que se impongan restricciones de edad para el acceso a los
        Servicios y funciones en línea, con arreglo a la legislación local.
      </p>
      <p>
        De igual manera, usted acepta, reconoce y autoriza que sean instalados
        otro tipo de software o programas, previo aviso, para poder llevar a
        cabo u ofrecer y completar con los Servicios y transacciones, como
        podría ser la instalación de un programa para poder utilizar la e-firma
        del SAT o reconocer su identidad mediante diversos algoritmos de
        identificación e individualización.
      </p>
      <p>
        La Empresa utiliza herramientas analíticas de terceros para recopilar
        datos, entre otros, sobre hábitos suyos y de otros usuarios respecto del
        uso del Servicio. Los datos así recopilados podrán contener, entre
        otros: identificadores únicos de identidad de dispositivos móviles u
        otros identificadores y ajustes de dispositivos, información sobre
        operadores, sistemas operativos y localización, fecha y tiempo dedicados
        al Servicio, otros parámetros y estadísticas, uso de funciones, tasas de
        conversión de anuncios, tasas de monetización y monitorización,
        historial de compras e información similar. La Empresa utiliza
        tecnologías de presentación de anuncios de terceros que pueden recopilar
        datos como resultado de la presentación de anuncios en los Servicios y
        susceptibles de presentar temporalmente anuncios en los Servicios. La
        información recopilada y utilizada para la presentación direccionada de
        anuncios puede contener, entre otros, datos sobre: edad y sexo, veces
        que se visualizó un anuncio, identidad única del dispositivo móvil u
        otros identificadores y ajustes de dispositivos, información acerca del
        uso del Servicio por su parte, terminal móvil compatible y otros sitios
        de Internet (incluyendo páginas y sitios web móviles de terceros) que
        haya visualizado (así como fecha y hora de visualización). Las
        herramientas analíticas y las tecnologías de presentación de anuncios
        pueden utilizar archivos de registro de servidor, balizas web, cookies,
        píxeles de seguimiento y demás tecnologías para recoger los mencionados
        datos, y combinar la información así recogida sobre otros Servicios con
        los datos recogidos de sitios web y productos y servicios móviles de
        terceros, así como con datos demográficos y publicitarios y encuestas de
        mercados y demás instrumentos de análisis.
      </p>
      <p>
        La información y datos que la empresa recopile o reúna podrá ser
        utilizada para fines comerciales, siempre y cuando no se relacione con
        sus datos personales, y se trate meramente como información estadística,
        o en caso de relacionarse deberá cumplir con las leyes en materia de
        tratamiento de datos personales y serle notificado al respecto en las
        Políticas de Privacidad de los Servicios.
      </p>
      <p>
        Aisladamente, esta información no puede considerarse datos personales;
        no obstante, si la empresa la combina con sus datos personales, podremos
        tratarla como datos personales en virtud de nuestra Política de
        Privacidad. La Empresa hace todo lo posible para proporcionarle vínculos
        a las políticas de privacidad de sus colaboradores en virtud de las
        cuales utilizan sus herramientas y tecnologías y, en la medida de lo
        posible, ofrecerle la posibilidad de optar por no utilizar los
        Servicios.
      </p>
      <p>
        Cuando esté utilizando los Servicios, éstos podrán monitorear la memoria
        de acceso aleatorio (RAM) de su hardware para comprobar si existen
        programas de terceros prohibidos conforme a los presentes Términos, que
        estén interactuando con los Servicios. En caso de que la empresa
        detectase dichos programas no autorizados, esta información, incluyendo
        el nombre de su Cuenta, su dirección de protocolo de Internet (IP),
        detalles acerca del programa no autorizado, y fecha y hora de detección
        del mismo, así como las especificaciones de su hardware y
        características de rendimiento del mismo, con o sin notificación
        adicional, ésta información le será comunicada y las acciones
        correspondientes serán adoptadas. Si se detecta el uso de un programa de
        terceros no autorizado, estos Términos, junto con los derechos
        inherentes a los mismos como lo puede ser, entre otros, el acceso por su
        parte a los Servicios, podrán revocarse, con o sin notificación
        adicional. No obstante, La Empresa no comparte y declina toda
        responsabilidad por las opiniones, consejos y/o recomendaciones
        presentadas o enviadas por Usted por medio de los Servicios. Dichas
        comunicaciones serán de exclusiva responsabilidad del Usuario que las
        envíe.
      </p>

      <h2>Publicidad, promoción de servicios e interacción entre usuarios.</h2>
      <p>
        La empresa, de manera plenamente discrecional y con sujeción únicamente
        a sus criterios editoriales, podrá destacar determinados servicios y/o
        servicios de terceros, mediante la inserción de enlaces promocionales,
        de banners publicitarios o de cualquier otro elemento publicitario y
        promocional, pudiendo llevar a cabo igualmente operaciones de
        comercialización cruzada con cualquier asociado de su elección. En tal
        caso, la empresa no es responsable de los servicios o servicios de
        terceras partes así destacados.
      </p>
      <h2>Limitación y exclusión de responsabilidad.</h2>
      <p>
        Usted, de manera expresa, reconoce que es el responsable único del uso
        que haga de los Servicios y de lo que ocurra en lo posterior a los
        mismos, sobre todo una vez que entable o surja su relación con otro
        Usuario.
      </p>
      <p>
        {" "}
        Los Servicios se facilitan tal cual se exhiben y se permite su uso. La
        Empresa no garantiza, ni asume ningún compromiso ni obligación, en
        relación con los resultados del uso de los Servicios ni de la relación
        entre los Usuarios, en términos de conformidad, exactitud, integridad,
        garantía, fiabilidad, seguridad, etcétera. La Empresa no ofrece ningún
        tipo de garantía en relación con el valor de mercado de los Servicios o
        de la relación jurídica o comercial posterior a los mismos, en relación
        con su satisfacción ni en relación con la idoneidad de los servicios
        para un determinado uso.{" "}
      </p>
      <p>
        Por otra parte, La Empresa no ofrece garantía alguna en el sentido de
        que los Servicios, incluyendo los servidores, software de terceros y/o
        proveedores y los programas informáticos necesarios para el
        funcionamiento de los mismos, estén exentos de interrupciones o de
        errores, defectos de software, virus o elementos dañinos, ni de que se
        corrija cualquier posible error. Por último, La Empresa no ofrece ningún
        tipo de garantía en el sentido de que la información, los Contenidos y/o
        los elementos a los que se puede acceder a través de los Servicios sean
        exactos, completos o actualizados.
      </p>
      <p>
        Más concretamente, La Empresa no verifica de un modo exhaustivo los
        Contenidos de todos los tipos ni los textos que usted u otros usuarios
        publican a través de los Servicios, ni tampoco sus acciones en el marco
        de los Servicios. La Empresa por lo tanto no ofrece ningún tipo de
        garantía, ni acepta ningún tipo de responsabilidad frente a usted, en
        relación con sus propias acciones y/o con las acciones de otros usuarios
        de los Servicios. Por último, La Empresa no podrá ser considerado
        responsable de los servicios de empresas ajenas, principalmente de los
        Usuarios o Proveedores, respecto del servicio que ofrece y de los
        Usuarios Interesados que le sean propuestos a los Usuarios Proveedores a
        través de La Empresa, ni tampoco ofrece ningún tipo de garantía en
        relación con tales servicios.
      </p>
      <p>
        El cliente cubrirá, y se obliga a, todos los costes y riesgos asociados
        con el uso de los Servicios.
      </p>
      <p>
        La Empresa no podrá en ningún caso ser obligada al pago a favor de Usted
        de cantidad alguna, ni de indemnización alguna en concepto de daños y
        perjuicios, en razón de su propia incapacidad para la utilización de la
        totalidad o parte de los Servicios. En ningún caso podrá tenerse a la
        empresa por responsable de ningún tipo de daño directo, indirecto,
        accidental, accesorio ni de cualquier otro daño derivado de la
        incapacidad del usuario para la utilización de los Servicios o de algún
        desenlace inesperado en lo posterior a los servicios o de la relación
        con otros Usuarios, incluso en el supuesto de que la empresa hubiera
        sido informado de la posibilidad de tales daños. En este orden de ideas,
        la empresa no es responsable de la relación comercial o jurídica que
        surja entre los Usuarios que se contacten a través de los Servicios, por
        lo que en ningún momento se le podrá relacionar con estas, ni involucrar
        en conflicto legal alguno, debido a las controversias que puedan surgir
        entre los usuarios respecto a la negociación que cada uno realice.
      </p>
      <p>
        Usted reconoce y acepta que, dentro de los límites que autoriza la ley,
        en el supuesto de que se diera una controversia con la empresa o con los
        otorgantes de licencias de ésta, usted podrá, dejar de utilizar los
        Servicios y poner fin a su Cuenta;
      </p>
      <p>
        En cualquier caso, la responsabilidad de la Empresa, frente a usted,
        nunca podrá ser superior al precio que usted hubiera abonado por los
        Servicios inmediatamente anteriores a la fecha en que ocurra la
        controversia. Dejando en claro el límite de los servicios que son los
        que se prestan en la plataforma digital y no las relaciones comerciales
        y jurídicas posteriores como podría ser la prestación de sus servicios
        profesionales. De igual forma, la empresa no estará obligado en ninguna
        forma, a responder por las obligaciones adquiridas respecto a portales
        de terceros.
      </p>
      <p>
        El Usuario o Cliente, reconoce que cualquier tercero, proveedores o
        prestadores de servicios, sobre todo otros Usuarios son independientes a
        la empresa, a los Servicios y a estos Términos, y que Usted es el único
        responsable de la relación jurídica y comercial con ellos o frente a
        ellos.
      </p>
      <p>
        Finalmente, en este acto, los Usuarios asumen y libera a la Empresa
        respecto de la responsabilidad civil que les correspondiere y que
        resulte del uso y operación comercial que se realice en cualquiera de
        los servicios otorgados por usuarios. En consecuencia, los Usuarios
        responderán directamente ante terceros, según corresponda, de los daños
        y/o perjuicios que se les pudiera causar a derechos y personas.
      </p>

      <h2>Modificación de los términos, software y/o servicios.</h2>
      <p>
        La empresa, se reserva el derecho de, en cualquier momento y de manera
        plenamente discrecional, cambiar, modificar, añadir o suprimir cláusulas
        en los presentes Términos y en las demás notificaciones incluidas en el
        sitio, tanto de manera provisional como de manera permanente.
      </p>
      <p>
        Por consiguiente, el cliente se compromete a comprobar periódicamente
        cualquier posible modificación y a observar las mismas íntegramente.
      </p>
      <p>
        La empresa se reserva el derecho de optimizar cualquiera de sus
        Servicios para una resolución y/o para un navegador diferente.
      </p>
      <p>
        Los Servicios le pueden solicitar permiso, o le pueden habilitar para
        que descargue programas informáticos, actualizaciones, parches y/u otras
        utilidades y herramientas suministradas por la empresa o por los
        concesionarios de licencias de ésta (denominados en lo sucesivo, el
        “Software de la empresa”) en su ordenador o en cualquier otro soporte
        autorizado por La empresa. La Empresa puede especificar con respecto al
        Software unos términos de uso específicos en el momento en que ponga el
        mismo a su disposición.
      </p>
      <p>
        Se le informa que los desarrollos informáticos no son compatibles con
        todos los soportes y plataformas digitales, en el sentido de que las
        prestaciones del Software de La Empresa y de los correspondientes
        Servicios pueden variar en función de su ordenador y del resto de su
        equipo.
      </p>
      <p>
        La Empresa puede ocasionalmente suministrarle actualizaciones o
        modificaciones del Software. Usted acepta que pueden resultar necesarias
        determinadas actualizaciones y modificaciones al objeto de poder seguir
        utilizando el Software y los Servicios.
      </p>
      <p>
        La empresa puede modificar los Contenidos o Servicios por cualquier
        causa, o sin especificar la causa, en cualquier momento, y en especial
        por razones vinculadas a cambios tecnológicos.
      </p>
      <p>
        En concreto, la empresa puede entender necesario llevar a cabo
        actualizaciones, operaciones de mantenimiento y/o reinicializaciones
        para mejorar y/u optimizar los Servicios. Estas actualizaciones,
        operaciones de mantenimiento y/o reinicializaciones pueden llegar a
        afectar los Servicios y/o a sus derechos adquiridos, o a cualquier otro
        elemento conexo.
      </p>
      <p>
        Por último, y con independencia de sus derechos al respecto, la empresa
        se reserva la facultad de: (a) restringir el acceso a la totalidad o
        parte de los Servicios a un determinado Usuario y/o (b) suprimir la
        totalidad o parte de los Servicios, y ello de manera plenamente
        discrecional, estando obligado la empresa únicamente a avisar a sus
        Usuarios previamente con por lo menos treinta (30) días de anticipación
        a la fecha en la que pretenda realizar dicha supresión, mediante una
        publicación en la plataforma digital correspondiente al Servicio que
        pretenda suprimir o a través de un correo electrónico, enviado a la
        dirección de correo registrada en la cuenta.
      </p>

      <h2>Modificación de las comisiones y precios.</h2>
      <p>
        La empresa se reserva el derecho de (i) modificar los precios de los
        Servicios facilitados o prestados, respecto de los costos y montos de
        las contraprestaciones de los mismos; y (ii) modificar un Servicio de un
        servicio de pago a un servicio gratuito, o viceversa, en el entendido de
        que los nuevos precios y costos se aplicarán únicamente a los pedidos
        vigentes tras la entrada en vigor, si procede, de los nuevos precios o
        costos.
      </p>

      <h2>Información sobre el bloqueo de elementos emergentes.</h2>
      <p>
        Su navegador puede estar configurado para impedir la visualización de
        elementos emergentes. Determinados contenidos se visualizan en forma de
        elementos emergentes. Para optimizar el uso, asegúrese de tener
        desactivada la función de bloqueo de elementos emergentes.
      </p>

      <h2>Privacidad.</h2>
      <p>
        Con fundamento en los artículos 15 y 16 de la Ley Federal de Protección
        de Datos Personales en Posesión de Particulares (en los sucesivo, la
        “Ley”) hacemos de su conocimiento que la empresa, con domicilio
        señalado, es responsable de recabar sus datos personales, del uso que se
        le dé a los mismos y de su protección. Se hace de su conocimiento que la
        información que como usuario se recaba de usted a través de la
        plataforma digital, será utilizada para las finalidades que se exponen
        en el Aviso de Privacidad correspondiente y que en todo momento podrá
        observar actualizadas en la página web del sitio que al efecto haya
        contratado.
      </p>

      <h2>Confidencialidad.</h2>
      <p>
        El cliente manifiesta que con la aceptación de los presentes Términos, y
        en razón de la relación que en virtud del uso del sitio, pudieren llegar
        a tener acceso a datos, información y documentos, o de terceros, que
        pudiera ser considerada de carácter confidencial y que sólo se divulga
        entre sí en virtud de la relación establecida en los presentes Términos
        y/o los contratos de prestación de servicios que al efecto se celebren
        entre los Usuarios. Por lo tanto, dicha información será tratada con el
        carácter de confidencial (“Información Confidencial”).
      </p>
      <p>
        La Información Confidencial incluye expresamente y sin limitación, toda
        la información que se divulgue, entre usted y la empresa o entre usted y
        terceros, por medio del sitio, en cualquier forma o que éstos lleguen a
        conocer previamente o durante la vigencia de su relación jurídica y
        comercial conforme a los presentes Términos, concerniente, relacionada o
        derivada de las actividades que cada una realiza; y que incluye
        procedimientos, técnicas, planes, proyectos, actividades, investigación,
        conocimientos técnicos, secretos industriales, prácticas comerciales,
        clientes, especificaciones, tecnología, información de clientes o de
        mercado, acuerdos contractuales, utilidades, ventas, políticas de
        precios, métodos operativos, procesos técnicos, políticas comerciales,
        prácticas y demás asuntos comerciales y métodos, planes y demás
        información técnica, legal, comercial y financiera, e información
        recibida de terceros que las partes estén obligadas a considerar como
        confidencial o propia y que pueda transmitirse por cualquier medio,
        incluyendo sin limitación, vía oral, visual, escrita y/o electrónica.
      </p>

      <h2>Marco legal y jurisdicción aplicables.</h2>
      <p>
        Los presentes Términos están materializados en un mensaje de datos en
        términos del artículo ochenta y nueve del Código de Comercio, por lo que
        de conformidad con el artículo ochenta y nueve bis del mismo
        ordenamiento no podrá negársele validez alguna por el simple hecho de
        hacerse constar en un mensaje de datos. Para tales efectos, tanto los
        Usuarios o clientes como la empresa reconocen que la celebración del
        presente acuerdo de voluntades traducido en estos Términos se celebra de
        conformidad con las disposiciones al efecto establecidas en el Capítulo
        I del Título Segundo del Código de Comercio Vigente en la República
        Mexicana.
      </p>
      <p>
        El cliente acuerda que el presente mensaje de datos contiene una oferta
        vinculante y creadora de obligaciones en el momento de su aceptación o
        de su uso, toda vez que la misma está formulada al público en general
        sin estar determinado algún destinatario o aceptante, por lo que los
        derechos y obligaciones contenidas en el presente contrato comenzarán en
        su vigencia a partir de la voluntad de Usted en aceptar las obligaciones
        contenidas en estos Términos y de que se cumplan correctamente con todas
        las condiciones suspensivas en los mismos y comience a hacer uso del
        sitio que la empresa pone a su disposición conforme a los presentes
        Términos.
      </p>
      <p>
        El cliente conviene en que, en todo lo establecido y no establecido en
        los presentes Términos, se estará a lo dispuesto en la legislación que
        al efecto resulte aplicable en el Estado de Jalisco, México. De igual
        manera, el cliente acuerda que en caso de que cualquier controversia,
        interpretación y/o cumplimiento de estos Términos deba someterse a
        decisión judicial, estas estarán a la jurisdicción y competencia
        exclusiva de los tribunales competentes en la ciudad de Guadalajara,
        Jalisco, México renunciando en este momento a cualquier otro fuero que
        pudiese corresponderles en razón de su domicilio presente o futuro, o
        por cualquier otra causa.
      </p>

      <h2>Contacto.</h2>
      <p>
        Los datos de contacto y medios oficiales de comunicación del
        representante y responsable legal de la empresa son los siguientes:
      </p>

      <table>
        <tbody>
          <tr>
            <th align="left" scope="row">
              Nombre comercial de la Empresa
            </th>
            <td>MULTIBURÓ</td>
          </tr>
          <tr>
            <th align="left" scope="row">
              Marca de la Empresa
            </th>
            <td>MULTIBURÓ</td>
          </tr>
          <tr>
            <th align="left" scope="row">
              Página web
            </th>
            <td>
              <a href="https://www.multiburo.com.mx/" target="_blank">
                www.multiburo.com.mx
              </a>
            </td>
          </tr>
          <tr>
            <th align="left" scope="row">
              Denominación social
            </th>
            <td>Multiburó SAPI de CV</td>
          </tr>
          <tr>
            <th align="left" scope="row">
              Nacionalidad de la Empresa
            </th>
            <td>Mexicana</td>
          </tr>
          <tr>
            <th align="left" scope="row">
              Correos electrónicos / Teléfonos (con clave de larga distancia, en
              su caso) / Otros medios de contacto
            </th>
            <td>
              <a href="mailto:contacto@multiburo.com.mx">
                contacto@multiburo.com.mx
              </a>
            </td>
          </tr>
          <tr>
            <th align="left" scope="row">
              Liga o link del sitio en el que se muestran los Servicios o
              Servicios de la empresa
            </th>
            <td>
              <a href="https://www.multiburo.com.mx/" target="_blank">
                www.multiburo.com.mx
              </a>
            </td>
          </tr>
        </tbody>
      </table>

      <br />
      <br />

      <strong className="p_center">
        <p>
          Los presentes Términos son de aplicación únicamente en la medida en
          que así lo autorice la ley. Cualquier utilización de los Servicios
          requiere la aceptación sin reserva de los presentes Términos.{" "}
        </p>

        <p>
          Le recomendamos añadir la página web a sus favoritos y consultar
          periódicamente este sitio para enterarse de cualquier posible
          actualización de los Términos.{" "}
        </p>

        <p>
          La Empresa recibirá con gusto sus opiniones, preguntas, inquietudes,
          comentarios o sugerencias a través de los medios oficiales de
          comunicación.{" "}
        </p>

        <p>
          Mediante la aceptación de los presentes Términos otorga su
          consentimiento para que la responsable, es decir La Empresa, actúe
          conforme a los Términos aquí planteados por medio de cualquiera de sus
          representantes legales.{" "}
        </p>

        <p>
          Con respecto a los servicios proporcionados por la empresa, puede
          visitar las siguientes páginas web en dónde encontrará información
          sobre sus derechos como consumidor y los mecanismos legales con los
          que cuenta para poder protegerlos:{" "}
        </p>

        <p>PROCURADURÍA FEDERAL DEL CONSUMIDOR</p>
        <p>
          <a href="https://www.gob.mx/profeco" target="_blank">
            www.profeco.gob.mx
          </a>
        </p>

        <p>
          INSTITUTO NACIONAL DE TRANSPARENCIA, ACCESO A LA INFORMACIÓN Y
          PROTECCIÓN DE DATOS PERSONALES
        </p>
        <p>
          <a href="https://home.inai.org.mx/" target="_blank" id="inai">
            www.inai.org.mx/
          </a>
        </p>
      </strong>
    </div>
  );
};

const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({
  open,
  onClose,
}) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-4xl min-w-0 sm:min-w-[750px] max-h-[90vh] flex flex-col">
        <DialogHeader className="flex-shrink-0">
          <DialogTitle className="text-lg font-semibold">
            TÉRMINOS Y CONDICIONES DE USO DE LOS SERVICIOS - MULTIBURÓ
          </DialogTitle>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto px-1">
          <div className="space-y-4 text-sm leading-relaxed">
            <TermsAndConditionsContent />
          </div>
        </div>

        <DialogFooter className="flex-shrink-0 pt-4">
          <Button onClick={onClose} variant="default">
            Aceptar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TermsAndConditions;
